const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { gql, useQuery } from '@apollo/client';
import unescapedText from 'I18n/utils/unescapedText';
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import throttle from 'transmute/throttle';
import { getFormattedAddress } from '../../../components/address/addressUtilities';
import { GenericErrorMessage } from '../../../components/errors/GenericErrorMessage';
import { BILLING_LIB_USER_PERMISSIONS_FRAGMENT, COMPANY_PROPERTIES_FRAGMENT, CONTACT_PROPERTIES_FRAGMENT } from '../../../graphQL/fragments';
import { useAuth } from '../../../utils/auth';
import { getAssociationProperties } from '../../../utils/common';
import { LoadingSkeleton, isCompany, isContact } from '../utils/commonUtils';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Typeahead } from 'foundations-components/transitional/components/Typeahead';
import { jsx as _jsx } from "react/jsx-runtime";
export const SEARCH_QUERY = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"SearchQuery\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"searchTerm\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"0\"}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"100\"}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"filters\"},\"value\":{\"kind\":\"ListValue\",\"values\":[]}}]}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"query\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"searchTerm\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"property\"},\"value\":{\"kind\":\"StringValue\",\"value\":\"createdate\",\"block\":false}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"order\"},\"value\":{\"kind\":\"EnumValue\",\"value\":\"DESC\"}}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"__typename\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"results\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"ContactProperties\"}},{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"CompanyProperties\"}},{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"BillingLibUserPermissionsFragment\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "SearchQuery"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "searchTerm"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "IntValue",
            value: "0"
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "IntValue",
            value: "100"
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "filters"
              },
              value: {
                kind: "ListValue",
                values: []
              }
            }]
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "query"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "searchTerm"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "property"
              },
              value: {
                kind: "StringValue",
                value: "createdate",
                block: false
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "order"
              },
              value: {
                kind: "EnumValue",
                value: "DESC"
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "__typename"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "results"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "ContactProperties"
                }
              }, {
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "CompanyProperties"
                }
              }, {
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "BillingLibUserPermissionsFragment"
                }
              }]
            }
          }]
        }
      }]
    }
  }].concat(COMPANY_PROPERTIES_FRAGMENT.definitions, CONTACT_PROPERTIES_FRAGMENT.definitions, BILLING_LIB_USER_PERMISSIONS_FRAGMENT.definitions))
});
const ObjectSelectListContainer = styled.div.withConfig({
  displayName: "ObjectSelectList__ObjectSelectListContainer",
  componentId: "vt5pqo-0"
})(["height:100%;ul[role='listbox']{max-height:100%;}"]);
const NO_RESULT_PLACEHOLDER = '--';
function getOptions(data, locale, objectId) {
  if (!data || !Array.isArray(data.crmObjectsSearch.results)) {
    return [];
  }
  const notSelected = obj => obj.id !== objectId;
  if (isCompany(data)) {
    return data.crmObjectsSearch.results.filter(notSelected).map(result => {
      var _result$avatar;
      const {
        name,
        address,
        address2,
        state,
        city,
        zip,
        country
      } = getAssociationProperties(result);
      return {
        text: name || NO_RESULT_PLACEHOLDER,
        help: getFormattedAddress({
          locale,
          address,
          address2,
          state,
          city,
          zip,
          country
        }).join(' ') || NO_RESULT_PLACEHOLDER,
        imageUrl: (_result$avatar = result.avatar) === null || _result$avatar === void 0 ? void 0 : _result$avatar.url,
        value: result.id
      };
    });
  }
  if (isContact(data)) {
    return data.crmObjectsSearch.results.filter(notSelected).map(result => {
      var _result$avatar2;
      const {
        firstname,
        lastname,
        email
      } = getAssociationProperties(result);
      const name = `${firstname || ''} ${lastname || ''}`.trim() || undefined;
      const subtext = name ? email || NO_RESULT_PLACEHOLDER : NO_RESULT_PLACEHOLDER;
      return {
        text: name || email || NO_RESULT_PLACEHOLDER,
        help: subtext,
        imageUrl: (_result$avatar2 = result.avatar) === null || _result$avatar2 === void 0 ? void 0 : _result$avatar2.url,
        value: result.id
      };
    });
  }
  return [];
}
const getThrottledSearchTerm = throttle(300, term => term);
export function ObjectSelectList({
  objectId,
  objectTypeId,
  onChange
}) {
  var _user$locale;
  const {
    user
  } = useAuth();
  const locale = (_user$locale = user === null || user === void 0 ? void 0 : user.locale) !== null && _user$locale !== void 0 ? _user$locale : 'en-us';
  const [searchTerm, setSearchTerm] = useState('');
  const throttledSearchTerm = useMemo(() => getThrottledSearchTerm(searchTerm), [searchTerm]);
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(SEARCH_QUERY, {
    variables: {
      objectTypeId,
      searchTerm: throttledSearchTerm
    },
    notifyOnNetworkStatusChange: true
  });
  if (loading && !searchTerm) {
    return /*#__PURE__*/_jsx(ObjectSelectListContainer, {
      "data-test-id": "object-select-list:loading",
      children: /*#__PURE__*/_jsx(View, {
        role: "listbox",
        margin: "0",
        padding: "0",
        as: "ul",
        children: Array(20).fill(0).map((_, i) => /*#__PURE__*/_jsx(LoadingSkeleton, {
          height: "3.5rem",
          width: "100%"
        }, `loading-skele-${i}`))
      })
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(ObjectSelectListContainer, {
      "data-test-id": "object-select-list:error",
      children: /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        children: /*#__PURE__*/_jsx(GenericErrorMessage, {
          onClick: () => {
            refetch().catch(() => {});
          }
        })
      })
    });
  }
  const handleOnSearchChange = event => {
    setSearchTerm(event.currentTarget.value);
  };
  return /*#__PURE__*/_jsx(ObjectSelectListContainer, {
    "data-test-id": "object-select-list",
    children: /*#__PURE__*/_jsx(Typeahead, {
      placeholder: unescapedText('commerceBillingLib.objectAssociator.common.labels.search'),
      onChange: event => {
        onChange(parseInt(event.target.value, 10));
      },
      onSearchChange: handleOnSearchChange,
      search: searchTerm,
      options: getOptions(data, locale, objectId),
      autoFilter: false
    })
  });
}